import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentService extends GenericService<any> {
  baseUrl = environment.BASE_URL
  constructor( private httpClient: HttpClient) {
    
    super(httpClient,'DocumentUploader/')
   }
   getDocumentById(documentId, ){
    return this.httpClient.get<any[]>(this.baseUrl +`DocumentUploader/${documentId}`, super.prepareHeader());
    }
}
